import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller, reset } from "react-hook-form";
import "../paymentLink/createPaymentLinks.css";
import {
  Autocomplete,
  Box,
  Checkbox,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/API_Client";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import NotifyModal from "./notifyModal";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { RiArrowDownSLine } from "react-icons/ri";
import "react-toastify/dist/ReactToastify.css";
import "../analytics/analytics.css";
import CustomDropdown from "../../reusableComponents/CustomDropdown";
import CustomButton from "../../reusableComponents/CustomButton";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import phonevalidator from "../utils/phoneValidation";
import { nameRegex } from "../../reusableComponents/constants";
import { useLocation, useNavigate } from "react-router-dom";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import DateTimeModal from "../modals/dateTimeModal";
import { v4 as uuidv4 } from "uuid";
import { colorBrandObject } from "../../../constants/brandings";
import { sortArrayValue } from "../utils/utils";

function CreatePaymentLinks() {
  const {
    uploadPaymentFormData,
    getAllModalData,
    getProductDetails,
    postPspConfigForFiltering,
    merchantSettings,
    editPaymentLink,
  } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state?.editData;
  const duplicateData = location.state?.duplicateData;
  const [responseData, setResponseData] = useState([]);
  const [paymentError, setPaymentError] = useState([]);
  const [disableFileds, setDisableFields] = useState(false);
  const [disableDuplicateFileds, setDisableDuplicateFields] = useState(false);
  const [currency, setCurrency] = useState([]);

  const [countryAndCountryCode, setCountryAndCountryCode] = useState();
  const [countryTitleArr, setCountryTitleArr] = useState();
  const [countryCodeArr, setCountryCodeArr] = useState();

  const [selectedCountryTitle, setSelectedCountryTitle] = useState();
  const [selectedCountryCode, setSelectedCountryCode] = useState();

  const [currencyDefaultValue, setCurrencyDefaultValue] = useState("");

  const [businessUnitsData, setBusinessUnitsData] = useState();
  const [businessNameArr, setBusinessNameArr] = useState();
  const [businessCodeArr, setBusinessCodeArr] = useState();

  const [selectedBusinessName, setSelectedBusinessName] = useState("");
  const [selectedBusinessCode, setSelectedBusinessCode] = useState("");

  const [open, setOpen] = useState(false);
  const [btnPressed, setBtnPressed] = useState();
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [productDescription, setProductDescription] = useState("");
  const [expiryTimeTitle, setExpiryTimeTitle] = useState("48 Hours");
  const [expiryTimeValue, setExpiryTimeValue] = useState(172800);

  const [countryLetter, setCountryLetter] = useState("");
  const [amount, setAmount] = useState("");
  const [maxAmount, setMaxAmount] = useState(0);
  const [minAmount, setMinAmount] = useState(0);
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [firstTimeEmailClicked, setFirstTimeEmailClicked] = useState(0);
  const [firstTimeSmsClicked, setFirstTimeSmsClicked] = useState(0);
  const [productTypeMandatory, setProductTypeMandatory] = useState(false);
  const [productDescriptionEditable, setProductDescriptionEditable] =
    useState(false);
  const [buttonState, setButtonState] = useState(1);
  const [isProductTypeChanged, setIsProductTypeChanged] = useState(false);
  const [toggleDialog, setToggleDialog] = useState(false);
  const [notifyViaEmail, setNotifyViaEmail] = useState(false);
  const [notifyViaSms, setNotifyViaSms] = useState(null);
  const [multiPaymentLink, setMultiPaymentLink] = useState(false);
  const [notifyViaSmsStatus, setNotifyViaSmsStatus] = useState(null);
  const [onDemandAmount, setOnDemandAmount] = useState(false);
  const [openDateModal, setOpenDateModal] = useState(false);
  const duplicateRef = useRef(true);
  const productDescriptionRef = useRef(true);
  const [merchantId, setMerchantId] = useState("");

  useEffect(() => {
    merchantSettings(
      (data) => {
        setProductTypeMandatory(data?.requiresProductCode);
        setProductDescriptionEditable(data?.editableProductDescription);
        setMerchantId(data?.merchantId);
      },
      (errMsg) => {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    if (editData || duplicateData) {
      productDescriptionRef.current = false;
    }
  }, [editData, duplicateData]);

  const expiryTimeData = [
    {
      title: "1 Hour",
      value: 3600,
    },
    {
      title: "2 Hour",
      value: 7200,
    },
    {
      title: "4 Hour",
      value: 14400,
    },
    {
      title: "6 Hour",
      value: 21600,
    },
    {
      title: "24 Hours",
      value: 86400,
    },
    {
      title: "48 Hours",
      value: 172800,
    },
    {
      title: "72 Hours",
      value: 259200,
    },
    {
      title: "96 Hours",
      value: 345600,
    },
    {
      title: "No Expiry",
      value: "null",
    },
  ];

  useEffect(() => {
    if (merchantId === "kXnv1OdwaY") {
      setExpiryTimeTitle("No Expiry");
      setExpiryTimeValue("null");
    } else {
      setExpiryTimeTitle("48 Hours");
      setExpiryTimeValue("172800");
    }
  }, [merchantId]);

  const paymentLinkTitle = /.*<[^>]+>.*/;

  const schema = yup.object({
    paymentLink: yup
      .string()
      .required("Title is required")
      .test(
        "no-html-tags",
        "HTML content is not allowed",
        (value) => !paymentLinkTitle.test(value)
      ),

    amount: yup
      .string()
      .required("Amount is required")
      .test({
        name: "greaterThanMin",
        message: minAmount
          ? `Amount should be greater than equal to ${minAmount}`
          : `Amount should be greater 0`,
        test: (value) =>
          selectedProduct
            ? minAmount
              ? parseFloat(value) >= minAmount
              : parseFloat(value) > 0
            : parseFloat(value) > 0,
      })
      .test({
        name: "lessThanMax",
        message: `Amount should be less than equal to ${maxAmount}`,
        test: (value) =>
          selectedProduct && maxAmount
            ? parseFloat(value) <= parseFloat(maxAmount)
            : true,
      }),

    mobileNumber: yup
      .string()
      .nullable()
      .test({
        name: "phone-validation",
        message: (value) => phonevalidator(value, countryLetter),
        test: (value) => {
          if (!value) return true;
          return !phonevalidator(value, countryLetter);
        },
      }),
    emailAddress: yup
      .string()
      .nullable()
      .trim()
      .matches(
        /(^$)|^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,})$/,
        "Please enter a valid email address"
      ),
    customerName: yup
      .string()
      .nullable()
      .test(
        "no-html-tags",
        "HTML content is not allowed",
        (value) => !paymentLinkTitle.test(value)
      ),
    orderId: yup
      .string()
      .nullable()
      .test(
        "no-html-tags",
        "HTML content is not allowed",
        (value) => !paymentLinkTitle.test(value)
      ),
  });

  const handleCountryChange = (country) => {
    setNotifyViaSms(false);
    setCountryLetter(country);
  };

  const { handleSubmit, control, formState, setValue, trigger, getValues } =
    useForm({
      resolver: yupResolver(schema),
    });

  useEffect(() => {
    const formData = getValues();
    formData?.mobileNumber !== undefined &&
      !isSubmitClicked &&
      setValue("mobileNumber", formData?.mobileNumber);
    formData?.mobileNumber !== undefined &&
      !isSubmitClicked &&
      trigger("mobileNumber");
  }, [countryLetter]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.location.href = "/paymentLinks";
  };

  useEffect(() => {
    const settingNotifyViaSmsStatus = JSON.parse(
      localStorage.getItem("merchantSettings")
    );
    setNotifyViaSmsStatus(settingNotifyViaSmsStatus?.notifyViaSmsEnabled);
    postPspConfigForFiltering(
      {},
      function (data) {
        setBusinessUnitsData(data?.legalEntities);
        const legalEntities = sortArrayValue(data?.legalEntities, "name")

        let names = [];
        let codes = [];
        for (let i = 0; i < legalEntities.length; i++) {
          codes.push(legalEntities[i]?.code);
          names.push(legalEntities[i]?.name);
        }
        setBusinessNameArr(names);
        setBusinessCodeArr(codes);
        if (editData === undefined && duplicateData === undefined && names?.length == 1) {
          setSelectedBusinessName(names[0]);
          setSelectedBusinessCode(codes[0]);
        }
      },
      function (errMsg) {

        customToast("error", "high", errMsg);
      }
    );
  }, [editData, duplicateData]);

  useEffect(() => {
    if (selectedBusinessCode) {
      postPspConfigForFiltering(
        { legalEntities: [selectedBusinessCode] },
        function (data) {
          setCurrency(data?.currencyCodes);
          setCountryAndCountryCode(data?.countryCodes);
          let codes = [];
          let titles = [];
          const countryCodes = sortArrayValue(data?.countryCodes, "title")
          for (let i = 0; i < countryCodes?.length; i++) {
            codes.push(countryCodes[i]?.value);
            titles.push(countryCodes[i]?.title);
          }

          setCountryCodeArr(codes);
          setCountryTitleArr(titles);
          if (!editData && !duplicateData) setSelectedCountryTitle(titles[0]);
          if (!editData && !duplicateData) setSelectedCountryCode(codes[0]);
          if (
            data?.currencyCodes &&
            data?.currencyCodes?.length > 0 &&
            !duplicateData
          ) {
            setCurrencyDefaultValue(data?.currencyCodes[0]?.value);
          }
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [selectedBusinessCode]);

  useEffect(() => {
    if (selectedBusinessCode) {
      duplicateRef.current = false;
      postPspConfigForFiltering(
        {
          legalEntities: [selectedBusinessCode],
          countryCodes: [selectedCountryCode],
        },
        function (data) {
          setCurrency(data?.currencyCodes);
          if (data?.currencyCodes && data?.currencyCodes?.length > 0) {
            setCurrencyDefaultValue(data?.currencyCodes[0]?.value);
          }
          setValue("mobileNumber", null);
          setValue("amount", "");
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [selectedCountryCode]);

  useEffect(() => {
    if (selectedBusinessCode && currencyDefaultValue) {
      getProductDetails(
        function (data) {
          let productDetails = data?.filter((productDetail) => {
            return (
              (productDetail?.currencyCode === currencyDefaultValue ||
                productDetail?.currencyCode === null) &&
              (productDetail?.businessUnits?.length == 0 ||
                !productDetail?.businessUnits ||
                productDetail?.businessUnits?.includes(selectedBusinessCode))
            );
          });

          if (productDetails?.length) {
            productDetails = sortArrayValue(productDetails, "name");
          }

          productDetails.map((product) => {
            return (product.nameAndCode = product.name + " - " + product.code);
          });

          setProductOptions(productDetails);
        },
        function (errMsg) {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [selectedBusinessCode, currencyDefaultValue]);

  useEffect(() => {
    if (productOptions?.length === 1) {
      setSelectedProduct(productOptions[0]);
    }
  }, [productOptions]);

  useEffect(() => {
    if (productOptions?.length === 0) {
      setProductDescriptionEditable(true);
    } else {
      merchantSettings(
        (data) => {
          setProductTypeMandatory(data?.requiresProductCode);
          setProductDescriptionEditable(data?.editableProductDescription);
          setMerchantId(data?.merchantId);
        },
        (errMsg) => {
          customToast("error", "high", errMsg);
        }
      );
    }
  }, [productOptions]);

  useEffect(() => {
    if (productOptions && productDescriptionRef) {
      selectedProduct
        ? productOptions.map((obj) => {
          if (obj?.code === selectedProduct?.code)
            setProductDescription(obj?.description);
        })
        : setProductDescription("");
      setMaxAmount(selectedProduct?.maxAmount ? selectedProduct?.maxAmount : 0);
      setMinAmount(selectedProduct?.minAmount ? selectedProduct?.minAmount : 0);
    }
  }, [selectedProduct, productDescriptionRef]);

  useEffect(() => {
    if (selectedProduct) {
      setSelectedProduct(null);
    }
  }, [selectedBusinessCode, selectedCountryCode, currencyDefaultValue]);

  useEffect(() => {
    if (editData) {
      const { firstName, lastName, email, phoneNumber } =
        editData?.data?.shopper;
      const matchingProduct = productOptions.find(
        (product) => product?.code === editData?.data?.productCode
      );
      const matchingBusinessUnit = businessUnitsData?.find(
        (product) =>
          product?.code === editData?.data?.context?.legalEntity?.code
      );
      const matchingExpirySec = expiryTimeData?.find(
        (ele) => ele?.value === editData?.data?.expiryDurationSec
      );
      const matchingCountry = countryAndCountryCode?.find(
        (ele) => ele?.value === editData?.data?.context?.countryCode
      )?.title;
      setDisableFields(true);
      setMultiPaymentLink(editData?.data?.multipleTransaction);
      setValue("orderId", editData?.data?.context?.orderId);
      setValue("mobileNumber", phoneNumber);
      const customerName =
        firstName && lastName
          ? `${firstName} ${lastName}`
          : firstName || lastName || "";
      setValue("customerName", customerName);
      if (phoneNumber) setNotifyViaSms(true);
      setValue("emailAddress", email);
      if (!matchingExpirySec) {
        setExpiryTimeTitle("No Expiry");
        setExpiryTimeValue("null");
      } else {
        setExpiryTimeTitle(matchingExpirySec?.title);
        setExpiryTimeValue(matchingExpirySec?.value);
      }
      if (email) setNotifyViaEmail(true);

      setSelectedBusinessName(matchingBusinessUnit?.name);
      setSelectedBusinessCode(matchingBusinessUnit?.code);
      if (matchingProduct) {
        setSelectedProduct(matchingProduct);
      }
      setProductDescription(editData?.data?.description);
      setSelectedCountryTitle(matchingCountry);
      setCurrencyDefaultValue(editData?.data?.currencyCode);
      setSelectedCountryCode(editData?.data?.context?.countryCode);
    }
  }, [editData, businessUnitsData, productOptions]);

  useEffect(() => {
    if (duplicateData && duplicateRef.current) {
      const matchingProduct = productOptions.find(
        (product) => product?.code === duplicateData?.data?.productCode
      );
      const matchingBusinessUnit = businessUnitsData?.find(
        (product) =>
          product?.code === duplicateData?.data?.context?.legalEntity?.code
      );

      const matchingExpirySec = expiryTimeData?.find(
        (ele) => ele?.value === duplicateData?.data?.expiryDurationSec
      );
      if (!matchingExpirySec) {
        setExpiryTimeTitle("No Expiry");
        setExpiryTimeValue("null");
      } else {
        setExpiryTimeTitle(matchingExpirySec?.title);
        setExpiryTimeValue(matchingExpirySec?.value);
      }
      const matchingCountry = countryAndCountryCode?.find(
        (ele) => ele?.value === duplicateData?.data?.context?.countryCode
      )?.title;
      setDisableDuplicateFields(true);
      if (!matchingExpirySec) {
        setExpiryTimeValue(null);
      } else {
        setExpiryTimeValue(duplicateData?.data?.expiryDurationSec);
      }
      setMultiPaymentLink(duplicateData?.data?.multipleTransaction);
      setSelectedBusinessName(matchingBusinessUnit?.name);
      setSelectedBusinessCode(matchingBusinessUnit?.code);
      setSelectedCountryTitle(matchingCountry);
      if (selectedBusinessCode) {
        postPspConfigForFiltering(
          {
            legalEntities: [selectedBusinessCode],
            countryCodes: [duplicateData?.data?.context?.countryCode],
          },
          function (data) {
            setCurrency(data?.currencyCodes);
          },
          function (errMsg) {
            customToast("error", "high", errMsg);
          }
        );
      }
      setSelectedCountryCode(duplicateData?.data?.context?.countryCode);
      setCurrencyDefaultValue(duplicateData?.data?.currencyCode);
      const { firstName, lastName, email } = duplicateData?.data?.shopper;
      const customerName =
        firstName && lastName
          ? `${firstName} ${lastName}`
          : firstName || lastName || "";
      setValue("customerName", customerName);
      setProductDescription(duplicateData?.data?.description);

      if (email) setNotifyViaEmail(true);
      if (matchingProduct) {
        setSelectedProduct(matchingProduct);
        setIsProductTypeChanged(true);
      }
    }
  }, [duplicateData, businessUnitsData, productOptions]);

  const generateChangingRuleToasterText = (selectionRuleName) => {
    let list = [];
    if (selectionRuleName == "Business Unit") {
      if (selectedCountryCode) list.push("Country");
      if (currencyDefaultValue) list.push("Currency");
      if (selectedProduct) list.push("Product Type");
    }
    if (selectionRuleName == "Country") {
      if (currencyDefaultValue) list.push("Currency");
      if (selectedProduct) list.push("Product Type");
    }
    if (selectionRuleName == "Currency") {
      if (selectedProduct) list.push("Product Type");
    }
    if (list.length <= 0) return null;

    let text = `Changing ${selectionRuleName} resets `;
    if (list.length == 1) return text + `${list[0]}`;
    for (let i = 0; i < list.length; i++) {
      if (i == list.length - 1) {
        text = text + ` and ${list[i]}`;
      } else if (i == 0) {
        text = text + ` ${list[i]}`;
      } else {
        text = text + `, ${list[i]}`;
      }
    }
    return text;
  };

  const [validDescription, setValidDescription] = useState(true);

  useEffect(() => {
    const htmlRegex = /.*<[^>]+>.*/;
    setValidDescription(!htmlRegex.test(productDescription));
  }, [productDescription]);

  const updateSelect = (id, val) => {
    let text = null;
    if (id === "businessUnit") {
      setSelectedBusinessName(
        businessUnitsData?.find((ele) => ele?.code === val)?.name
      );
      setSelectedBusinessCode(val);
      text = generateChangingRuleToasterText("Business Unit");
      text && customToast("warning", "medium", text);
    }
    if (id === "country") {
      setSelectedCountryTitle(
        countryAndCountryCode?.find((ele) => ele?.value === val)?.title
      );
      setSelectedCountryCode(val);
      text = generateChangingRuleToasterText("Country");
      text && customToast("warning", "medium", text);
    }
    if (val === "custom") {
      setOpenDateModal(true);
    } else if (id === "expiryTime") {
      setExpiryTimeTitle(
        expiryTimeData?.find((ele) => ele?.value === val)?.title
      );
      setExpiryTimeValue(val);
    } else if (id === "customExpiryTime") {
      setExpiryTimeTitle(val.title);
      setExpiryTimeValue(val?.value);
    }
  };

  const onSubmit = (formData, event) => {
    if (
      (productTypeMandatory === true &&
        productOptions?.length &&
        selectedProduct) ||
      productTypeMandatory === false ||
      productTypeMandatory === null ||
      productOptions?.length === 0
    ) {
      setButtonState(0);
      const fullUuid = uuidv4();
      const shortUuid = fullUuid.replace(/-/g, "").substring(0, 10);
      const nameParts = formData?.customerName?.split(" ") || [];
      const firstName = nameParts[0] || null;
      const lastName =
        nameParts.length > 1 ? nameParts.slice(1).join(" ") : null;
      let payload = {
        title: formData?.paymentLink,
        productCode: selectedProduct?.code,
        description:
          productDescriptionEditable && productDescription
            ? productDescription
            : null,
        multipleTransaction: multiPaymentLink,
        context: {
          countryCode: selectedCountryCode,
          legalEntity: {
            code: selectedBusinessCode,
          },
          orderId: formData?.orderId,
        },
        paymentType: "S",
        money: {
          amount: formData?.amount,
          currencyCode: currencyDefaultValue,
        },
        shopper: {
          uniqueReference: formData?.mobileNumber
            ? formData?.mobileNumber
            : shortUuid,
          email: formData?.emailAddress,
          phoneNumber: formData?.mobileNumber,
          firstName: firstName,
          lastName: lastName,
        },
        notifyViaEmail: notifyViaEmail,
        notifyViaSms: notifyViaSms,
        expiryDurationSec: expiryTimeValue,
        onDemandAmount: onDemandAmount,
      };

      if (!onDemandAmount) delete payload.onDemandAmount;
      uploadPaymentFormData(
        payload,
        function (responseData) {
          setButtonState(1);
          setResponseData(responseData);
          setNotifyViaEmail(false);
          setNotifyViaSms(false);
          setValue("businessUnit", "");
          setValue("paymentLink", "");
          setValue("amount", "");
          setValue("orderId", "");
          setValue("description", "");
          setValue("mobileNumber", "");
          setValue("emailAddress", "");
          setBtnPressed(null);
          setSelectedProduct(null);
          setIsProductTypeChanged(false);
          handleOpen();
          setIsSubmitClicked(true);
        },

        function (errMsg) {
          setButtonState(1);
          customToast("error", "high", errMsg);
          setPaymentError(errMsg);
        }
      );
    }
  };

  const handleEditPaymentLink = (formData) => {
    if (formData) {
      setToggleDialog(true);
    }
  };
  const handleEditModal = (formData) => {
    const fullUuid = uuidv4();
    const shortUuid = fullUuid.replace(/-/g, "").substring(0, 10);
    const nameParts = formData?.customerName?.split(" ") || [];
    const firstName = nameParts[0] || null;
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : null;
    editPaymentLink(
      editData?.token,
      {
        notifyViaEmail: notifyViaEmail,
        notifyViaSms: notifyViaSms,
        description:
          productDescriptionEditable && productDescription
            ? productDescription
            : null,
        money: {
          amount: formData.amount,
          currencyCode: currencyDefaultValue,
        },
        multipleTransaction: multiPaymentLink,
        context: {
          orderId: formData?.orderId,
        },
        shopper: {
          uniqueReference: formData?.mobileNumber
            ? formData?.mobileNumber
            : shortUuid,
          email: formData?.emailAddress,
          phoneNumber: formData?.mobileNumber,
          firstName: firstName,
          lastName: lastName,
        },
        notifyViaEmail: notifyViaEmail,
        notifyViaSms: notifyViaSms,
        expiryDurationSec: expiryTimeValue,
        productCode: selectedProduct?.code,
      },
      function (data) {
        if (data) {
          setToggleDialog(false);
          setResponseData(data);
          handleOpen();
        }
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };
  const handleCloseDateModal = (operation) => {
    if (operation === "cancel") {
      let timeData = expiryTimeData?.find((ele) => ele?.value === 172800);
      setExpiryTimeTitle(timeData?.title);
      setExpiryTimeValue(timeData?.value);
    }
    setOpenDateModal(false);
  };
  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div className="payment-link-main-div">
            <ContentHeader
              firstHeading={
                editData
                  ? "Edit Payment Link"
                  : "Get paid instantly with your unique Payment link"
              }
              secondHeading={
                editData
                  ? "Payment Link:"
                  : "Instantly create payment links and inform your customers via SMS or email for quick and easy transactions."
              }
              url={editData?.data?.paymentUrl}
              icon={
                editData ? (
                  <BorderColorIcon
                    sx={{
                      color: colorBrandObject.sideBarSelectedOptionBackground,
                    }}
                  />
                ) : (
                  <InsertLinkIcon
                    sx={{
                      color: colorBrandObject.sideBarSelectedOptionBackground,
                    }}
                  />
                )
              }
            />

            <form className="form-div">
              <div className="payment-link-g0">
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel
                      htmlFor="businessCode"
                      className="fontCreate"
                      required
                    >
                      Business Unit
                    </InputLabel>
                    <div style={{ display: "flex", width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        {!!businessNameArr?.length && (
                          <CustomDropdown
                            width={"100%"}
                            height={"40px"}
                            optionsToDisplay={businessNameArr}
                            optionsToSend={businessCodeArr}
                            defaultValue={selectedBusinessName}
                            dropDownId={"businessUnit"}
                            updateSelect={updateSelect}
                            placeholder={"Select Business Unit"}
                            disabled={
                              editData ? disableFileds : disableDuplicateFileds
                            }
                          />
                        )}
                        {!businessNameArr?.length && (
                          <CustomDropdown width={"100%"} height={"40px"} />
                        )}

                        {!selectedBusinessCode && btnPressed && (
                          <p
                            className="error"
                            style={{
                              color: "#B9232F",
                              fontSize: "10px",
                              marginTop: "2px",
                            }}
                          >
                            <img
                              src="/assets/errorOutline.svg"
                              style={{ height: "12px", width: "12px" }}
                            />{" "}
                            {"Please select a Business Unit"}
                          </p>
                        )}
                      </div>
                    </div>
                  </Box>
                </div>
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel
                      htmlFor="country"
                      className="fontCreate"
                      required={true}
                    >
                      Country
                    </InputLabel>

                    <div style={{ display: "flex", width: "100%" }}>
                      <div style={{ width: "100%" }}>
                        {selectedCountryTitle && (
                          <CustomDropdown
                            width={"100%"}
                            height={"40px"}
                            optionsToDisplay={countryTitleArr}
                            optionsToSend={countryCodeArr}
                            defaultValue={selectedCountryTitle}
                            dropDownId={"country"}
                            updateSelect={updateSelect}
                            disabled={disableFileds}
                          />
                        )}
                        {!selectedCountryTitle && (
                          <CustomDropdown width={"100%"} height={"40px"} disabled={true} />
                        )}
                        {!selectedCountryCode && btnPressed && (
                          <p
                            className="error"
                            style={{
                              color: "#B9232F",
                              fontSize: "10px",
                              marginTop: "2px",
                            }}
                          >
                            <img
                              src="/assets/errorOutline.svg"
                              style={{ height: "12px", width: "12px" }}
                            />{" "}
                            {"Please select a Country"}
                          </p>
                        )}
                      </div>
                    </div>
                  </Box>
                </div>
              </div>
              <div className="payment-link-g1">
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel
                      htmlFor="paymentLink"
                      className="fontCreate"
                      required
                    >
                      Title
                    </InputLabel>
                    <Controller
                      name="paymentLink"
                      control={control}
                      defaultValue={
                        editData?.data?.title ||
                        duplicateData?.data?.title ||
                        ""
                      }
                      render={({ field }) => (
                        <OutlinedInput
                          {...field}
                          id="paymentLink"
                          placeholder="Reason for Payment"
                          aria-describedby="outlined-name-helper-text"
                          sx={{ width: "100%", fontFamily: "Poppins" }}
                          onChange={(event) => {
                            setValue("paymentLink", event.target.value);
                            trigger("paymentLink");
                          }}
                          disabled={disableFileds}
                        />
                      )}
                    />
                    {formState?.errors?.paymentLink && (
                      <p
                        className="error"
                        style={{
                          color: "#B9232F",
                          fontSize: "10px",
                          marginTop: "2px",
                        }}
                      >
                        <img
                          src="/assets/errorOutline.svg"
                          style={{ height: "12px", width: "12px" }}
                        />{" "}
                        {formState?.errors?.paymentLink?.message}
                      </p>
                    )}
                  </Box>
                </div>
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel htmlFor="orderId" className="fontCreate">
                      Order/Reservation Id
                    </InputLabel>

                    <Controller
                      name="orderId"
                      control={control}
                      render={({ field }) => (
                        <OutlinedInput
                          {...field}
                          id="orderId"
                          placeholder="Order/Reservation Id"
                          aria-describedby="outlined-name-helper-text"
                          sx={{ width: "100%", fontFamily: "Poppins" }}
                          onChange={(event) => {
                            setValue("orderId", event.target.value);
                            trigger("orderId");
                          }}
                          disabled={
                            editData?.data?.context?.orderId && disableFileds
                          }
                        />
                      )}
                    />
                    {formState?.errors?.orderId && (
                      <p
                        className="error"
                        style={{
                          color: "#B9232F",
                          fontSize: "10px",
                          marginTop: "2px",
                        }}
                      >
                        <img
                          src="/assets/errorOutline.svg"
                          style={{
                            height: "12px",
                            width: "12px",
                            marginTop: "2px",
                          }}
                        />{" "}
                        {formState?.errors?.orderId?.message}
                      </p>
                    )}
                  </Box>
                </div>
              </div>
              <div className="payment-link-g2">
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel
                      htmlFor="amount"
                      className="fontCreate"
                      required={true}
                    >
                      Amount
                    </InputLabel>
                    <div style={{ display: "flex" }}>
                      <Controller
                        name="currency"
                        control={control}
                        render={({ field }) => (
                          <Select
                            {...field}
                            className="hideBorder"
                            sx={{
                              width: "84px !important",
                              borderRadius: "4px 0 0 4px",
                              "& .MuiSelect-icon": {
                                right: "12px",
                                position: "absolute",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "grey",
                                width: "12px",
                              },
                            }}
                            value={currencyDefaultValue}
                            onChange={(e) => {
                              let text = null;
                              setCurrencyDefaultValue(e.target.value);
                              text =
                                generateChangingRuleToasterText("Currency");
                              text && customToast("warning", "medium", text);
                            }}
                            IconComponent={RiArrowDownSLine}
                            disabled={disableFileds}
                          >
                            {currency?.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                <div style={{ marginLeft: "10px" }}>
                                  {option.value}
                                </div>
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />

                      <Controller
                        name="amount"
                        control={control}
                        defaultValue={
                          editData?.data?.amount ||
                          duplicateData?.data?.amount ||
                          ""
                        }
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            placeholder="Enter amount"
                            sx={{
                              width: "100%",
                              borderRadius: "0 4px 4px 0",
                              borderLeft: "none !important",
                            }}
                            inputProps={{
                              pattern: "[0-9.]*",
                            }}
                            onChange={(event) => {
                              const inputValue = event.target.value.replace(
                                /[^0-9.]/g,
                                ""
                              );

                              setValue("amount", inputValue);
                              trigger("amount");
                            }}
                          />
                        )}
                      />
                    </div>
                    {formState?.errors?.amount && (
                      <p
                        className="error"
                        style={{
                          color: "#B9232F",
                          fontSize: "10px",
                          marginTop: "2px",
                          alignItems: "center",
                          marginBottom: "0px",
                        }}
                      >
                        <img
                          src="/assets/errorOutline.svg"
                          style={{ height: "12px", width: "12px" }}
                        />{" "}
                        {formState?.errors?.amount?.message}
                      </p>
                    )}
                  </Box>
                  <Box
                    sx={{
                      p: "4px 0 0 4px",
                      paddingTop: formState?.errors?.amount ? "0px" : "4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginTop: formState?.errors?.amount ? "-1px" : "4px",
                    }}
                    className="notifySize notifySmsSize"
                  >
                    <Checkbox
                      style={{
                        height: "4px",
                        width: "4px",
                        cursor: "pointer",
                      }}
                      checked={onDemandAmount}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: colorBrandObject?.secondaryButtonColor,
                        },
                        "&.Mui-checked": {
                          color: colorBrandObject?.secondaryButtonColor,
                          "& .MuiSvgIcon-root": {
                            fill: colorBrandObject?.secondaryButtonColor,
                          },
                        },
                      }}
                      onClick={(e) => setOnDemandAmount((prev) => !prev)}
                    />
                    <Typography
                      variant="body2"
                      className="notifySmsText"
                      onClick={(e) => {
                        setOnDemandAmount(state => !state);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Let Customer Edit Amount
                    </Typography>
                  </Box>
                </div>
                <div className="fieldContainer">
                  <Box sx={{ p: "0 0 5px 0" }}>
                    <InputLabel htmlFor="customerName" className="fontCreate">
                      Customer Name
                    </InputLabel>
                    <Controller
                      name="customerName"
                      control={control}
                      render={({ field }) => (
                        <OutlinedInput
                          {...field}
                          id="customerName"
                          placeholder="Customer Name"
                          aria-describedby="outlined-name-helper-text"
                          sx={{ width: "100%", fontFamily: "Poppins" }}
                          onChange={(event) => {
                            setValue("customerName", event.target.value);
                            trigger("customerName");
                          }}
                        />
                      )}
                    />
                    {formState?.errors?.customerName && (
                      <p
                        className="error"
                        style={{
                          color: "#B9232F",
                          fontSize: "10px",
                          marginTop: "2px",
                        }}
                      >
                        <img
                          src="/assets/errorOutline.svg"
                          style={{ height: "12px", width: "12px" }}
                        />{" "}
                        {formState?.errors?.customerName?.message}
                      </p>
                    )}
                  </Box>
                </div>
              </div>
              <div className="payment-link-g3">
                <div className="payment-link-g3-2">
                  {productOptions?.length > 0 ? (
                    <div className="fieldContainer2">
                      <Box sx={{ p: "0 0 5px 0" }}>
                        <InputLabel
                          htmlFor="orderId"
                          className="fontCreate"
                          required={productTypeMandatory}
                        >
                          Product Type
                        </InputLabel>
                        <div style={{ width: "100%" }}>
                          <Autocomplete
                            multiple={false}
                            options={productOptions}
                            getOptionLabel={(option) => option?.nameAndCode}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>{option?.nameAndCode}</li>
                            )}
                            isOptionEqualToValue={(option, value) =>
                              option?.nameAndCode === value?.nameAndCode
                            }
                            value={selectedProduct}
                            onChange={(e, newValue) => {
                              setIsProductTypeChanged(true);
                              setSelectedProduct(newValue);
                            }}
                            renderTags={() => null}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                sx={{ fontFamily: "Poppins" }}
                                placeholder="Select the type of product"
                              />
                            )}
                          />
                        </div>
                        {productTypeMandatory &&
                          (btnPressed || isProductTypeChanged) &&
                          selectedProduct === null && (
                            <p
                              className="error"
                              style={{
                                color: "#B9232F",
                                fontSize: "10px",
                                marginTop: "2px",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src="/assets/errorOutline.svg"
                                style={{ height: "12px", width: "12px" }}
                              />{" "}
                              Product type is required
                            </p>
                          )}
                      </Box>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="fieldContainer3">
                    <Box
                      sx={{
                        p: "0 0 5px 0",
                        width: "auto",
                      }}
                    >
                      <InputLabel htmlFor="description" className="fontCreate">
                        Description
                      </InputLabel>
                      <Controller
                        name="description"
                        control={control}
                        render={({ field }) => (
                          <OutlinedInput
                            {...field}
                            value={productDescription}
                            id="description"
                            placeholder="A small description"
                            multiline
                            rows={productOptions?.length > 0 ? 6 : 10}
                            aria-describedby="outlined-name-helper-text"
                            sx={{ width: "100%", fontFamily: "Poppins" }}
                            onChange={(e) => {
                              if (productDescriptionEditable) {
                                const newValue = e.target.value;
                                setProductDescription(newValue);
                                field.onChange(e);
                              }
                            }}
                          />
                        )}
                      />

                      {!validDescription && (
                        <Typography
                          className="error"
                          style={{
                            color: "#B9232F",
                            fontSize: "10px",
                            marginTop: "3px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "15px", width: "12px" }}
                          />{" "}
                          HTML content is not allowed
                        </Typography>
                      )}
                    </Box>
                  </div>
                  <Box
                    sx={{
                      p: "4px 0 0 4px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor:
                        editData?.data &&
                          Object.keys(editData?.data?.transactionDetails)?.length
                          ? "not-allowed"
                          : "pointer",
                      opacity:
                        editData?.data &&
                          Object.keys(editData?.data?.transactionDetails)?.length
                          ? 0.8
                          : 1,
                    }}
                    onClick={
                      editData?.data &&
                        Object.keys(editData?.data?.transactionDetails)?.length
                        ? undefined
                        : () => setMultiPaymentLink(!multiPaymentLink)
                    }
                  >
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: colorBrandObject?.secondaryButtonColor,
                        },
                        "&.Mui-checked": {
                          color: colorBrandObject?.secondaryButtonColor,
                          "& .MuiSvgIcon-root": {
                            fill: colorBrandObject?.secondaryButtonColor,
                          },
                        },
                      }}
                      checked={multiPaymentLink}
                      disabled={
                        editData?.data &&
                        Object.keys(editData?.data?.transactionDetails)?.length
                      }
                    />
                    <Typography
                      className="bodyB2Medium font-black-high"
                      style={{
                        cursor:
                          editData?.data &&
                            Object.keys(editData?.data?.transactionDetails)
                              ?.length
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      Enable Multi-Payment Link
                    </Typography>
                  </Box>
                </div>
                <div className="payment-link-g3-2">
                  <div
                    className="fieldContainer2"
                    style={{
                      marginBottom: notifyViaSmsStatus
                        ? formState?.errors?.mobileNumber
                          ? "28px"
                          : "20px"
                        : formState?.errors?.mobileNumber
                          ? "12px"
                          : "0px",
                    }}
                  >
                    <Box sx={{ p: "0 0 5px 0" }}>
                      <InputLabel htmlFor="mobileNumber" className="fontCreate">
                        Customer Mobile Number
                      </InputLabel>
                      <Controller
                        name="mobileNumber"
                        control={control}
                        render={({ field }) => (
                          <PhoneInput
                            style={{
                              paddingTop: "-40px",
                              paddingLeft: "9px",
                              height: "42px",
                              borderRadius: "4px",
                              border: "1.4px solid var(--neutral-5, #CBCACA)",
                              color: "black",
                              fontFamily: "Poppins",
                            }}
                            {...field}
                            international
                            onCountryChange={(country) =>
                              handleCountryChange(country)
                            }
                            onChange={(value) => {
                              if (value === undefined || null) {
                                setFirstTimeSmsClicked(0);
                                setNotifyViaSms(false);
                              } else {
                                if (
                                  value?.includes("+91") &&
                                  countryLetter == "IN"
                                ) {
                                  setFirstTimeSmsClicked(1);
                                  notifyViaSmsStatus && setNotifyViaSms(true);
                                }
                              }
                              setValue("mobileNumber", value);
                              trigger("mobileNumber");
                            }}
                            countryCallingCodeEditable={false}
                            defaultCountry={selectedCountryCode}
                          />
                        )}
                      />
                      {formState?.errors?.mobileNumber && (
                        <p
                          className="error"
                          style={{
                            color: "#B9232F",
                            fontSize: "10px",
                            marginTop: "2px",
                            alignItems: "center",
                            marginBottom: "0px",
                          }}
                        >
                          <img
                            src="/assets/errorOutline.svg"
                            style={{ height: "12px", width: "12px" }}
                          />{" "}
                          {formState.errors.mobileNumber.message}
                        </p>
                      )}
                    </Box>
                    {countryLetter == "IN" && notifyViaSmsStatus && (
                      <Box
                        sx={{
                          p: "4px 0 0 4px",
                          paddingTop: formState?.errors?.mobileNumber
                            ? "0px"
                            : "4px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          marginTop: formState?.errors?.mobileNumber
                            ? "-1px"
                            : "4px",
                        }}
                        className="notifySize notifySmsSize"
                      >
                        <Checkbox
                          style={{
                            height: "4px",
                            width: "4px",
                            cursor: "pointer",
                          }}
                          checked={notifyViaSms}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              color: colorBrandObject?.secondaryButtonColor,
                            },
                            "&.Mui-checked": {
                              color: colorBrandObject?.secondaryButtonColor,
                              "& .MuiSvgIcon-root": {
                                fill: colorBrandObject?.secondaryButtonColor,
                              },
                            },
                          }}
                          onClick={(e) => {
                            if (notifyViaSms) {
                              setFirstTimeSmsClicked(-1);
                            } else {
                              setFirstTimeSmsClicked(0);
                            }
                            setNotifyViaSms(!notifyViaSms);
                          }}
                        />
                        <Typography
                          variant="body2"
                          className="notifySmsText"
                          onClick={(e) => {
                            if (notifyViaSms) {
                              setFirstTimeSmsClicked(-1);
                            } else {
                              setFirstTimeSmsClicked(0);
                            }
                            setNotifyViaSms(!notifyViaSms);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          Notify via SMS
                        </Typography>
                      </Box>
                    )}
                  </div>
                  <div>
                    <div className="fieldContainer2">
                      <Box sx={{ p: "0 0 5px 0", marginTop: "-2px" }}>
                        <InputLabel
                          htmlFor="emailAddress"
                          className="fontCreate"
                        >
                          Customer Email Address
                        </InputLabel>
                        <Controller
                          name="emailAddress"
                          control={control}
                          render={({ field }) => (
                            <OutlinedInput
                              {...field}
                              id="emailAddress"
                              size="small"
                              name="emailAddress"
                              placeholder="Email Address"
                              aria-describedby="outlined-title-helper-text"
                              sx={{ width: "100%", fontFamily: "Poppins" }}
                              onChange={(e) => {
                                if (e.target.value === "") {
                                  setFirstTimeEmailClicked(0);
                                  setNotifyViaEmail(false);
                                } else {
                                  if (firstTimeEmailClicked == 0) {
                                    setFirstTimeEmailClicked(1);
                                    setNotifyViaEmail(true);
                                  }
                                }
                                setValue("emailAddress", e.target.value);
                                trigger("emailAddress");
                              }}
                            />
                          )}
                        />
                        {formState?.errors?.emailAddress && (
                          <p
                            className="error"
                            style={{
                              color: "#B9232F",
                              fontSize: "10px",
                              marginTop: "2px",
                            }}
                          >
                            <img
                              src="/assets/errorOutline.svg"
                              style={{
                                height: "12px",
                                width: "12px",
                                marginTop: "2px",
                              }}
                            />{" "}
                            {formState?.errors?.emailAddress?.message}
                          </p>
                        )}
                      </Box>
                    </div>
                    <Box
                      sx={{
                        p: "4px 0 0 4px",
                        paddingTop: formState?.errors?.emailAddress
                          ? "12px"
                          : "4px",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                      className="notifySize"
                    >
                      <Checkbox
                        style={{
                          height: "4px",
                          width: "4px",
                          cursor: "pointer",
                        }}
                        checked={notifyViaEmail}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: colorBrandObject?.secondaryButtonColor,
                          },
                          "&.Mui-checked": {
                            color: colorBrandObject?.secondaryButtonColor,
                            "& .MuiSvgIcon-root": {
                              fill: colorBrandObject?.secondaryButtonColor,
                            },
                          },
                        }}
                        onClick={(e) => {
                          if (notifyViaEmail) {
                            setFirstTimeEmailClicked(-1);
                          } else {
                            setFirstTimeEmailClicked(0);
                          }
                          setNotifyViaEmail(!notifyViaEmail);
                        }}
                      />
                      <Typography
                        variant="body2"
                        className="notifyText"
                        onClick={(e) => {
                          if (notifyViaEmail) {
                            setFirstTimeEmailClicked(-1);
                          } else {
                            setFirstTimeEmailClicked(0);
                          }
                          setNotifyViaEmail(!notifyViaEmail);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        Notify via Email
                      </Typography>
                    </Box>
                  </div>

                  <div className="fieldContainer2">
                    <Box sx={{ p: "0 0 5px 0" }}>
                      <div
                        style={{ display: "flex", alignItems: "center" }}
                        className="iconSpacing"
                      >
                        <InputLabel
                          htmlFor="Expiry"
                          className="fontCreate"
                          required
                        >
                          Expiry
                        </InputLabel>
                        {editData && (
                          <Tooltip title="Once the link is edited, the expiry timer will reset.">
                            <IconButton
                              sx={{
                                "&:hover": { backgroundColor: "transparent" },
                              }}
                              disableFocusRipple
                              disableTouchRipple
                            >
                              <InfoOutlinedIcon
                                sx={{
                                  color:
                                    "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                                  width: "14px",
                                  height: "14px",
                                  order: 1,
                                  marginLeft: "2px",
                                  marginBottom: "8px",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>
                      <div style={{ display: "flex", width: "100%" }}>
                        <div style={{ width: "100%" }}>
                          {selectedBusinessName && (
                            <CustomDropdown
                              width={"100%"}
                              height={"40px"}
                              optionsToDisplay={[
                                "1 Hour",
                                "2 Hour",
                                "4 Hour",
                                "6 Hour",
                                "24 Hours",
                                "48 Hours",
                                "72 Hours",
                                "96 Hours",
                                "Custom Date & Time",
                                "No Expiry",
                              ]}
                              optionsToSend={[
                                3600,
                                7200,
                                14400,
                                21600,
                                86400,
                                172800,
                                259200,
                                345600,
                                "custom",
                                "null",
                              ]}
                              defaultValue={expiryTimeTitle}
                              dropDownId={"expiryTime"}
                              updateSelect={updateSelect}
                            />
                          )}
                          {!selectedBusinessName && (
                            <CustomDropdown width={"100%"} height={"40px"} />
                          )}

                          {!selectedBusinessCode && btnPressed && (
                            <p
                              className="error"
                              style={{
                                color: "#B9232F",
                                fontSize: "10px",
                                marginTop: "2px",
                              }}
                            >
                              <img
                                src="/assets/errorOutline.svg"
                                style={{ height: "12px", width: "12px" }}
                              />{" "}
                              {"Please select a Business Unit"}
                            </p>
                          )}
                        </div>
                      </div>
                    </Box>
                  </div>
                </div>
              </div>
            </form>
            <div className="btn-container" onClick={(e) => setBtnPressed(true)}>
              <CustomButton
                text={"Cancel"}
                type={"primary"}
                size={"sm"}
                variant={"outlined"}
                onClick={() => navigate("/paymentLinks")}
              />
              <div style={{ marginLeft: "12px" }}>
                <CustomButton
                  text={
                    editData
                      ? "Save Changes"
                      : buttonState === 0
                        ? "Creating..."
                        : "Create Link"
                  }
                  type={"primary"}
                  size={"sm"}
                  variant={"contained"}
                  onClick={() => {
                    if (editData) {
                      handleSubmit(handleEditPaymentLink)();
                    } else {
                      handleSubmit(onSubmit)();
                    }
                  }}
                  disabled={buttonState === 0}
                />
              </div>
            </div>
          </div>

          <NotifyModal
            open={open}
            onClose={handleClose}
            responseData={responseData}
            editData={editData}
          />

          <SmallModal
            headerText={"Info"}
            subHeaderText={"Are you sure you want to save the changes?"}
            outlinedBtnText={"Cancel"}
            outlinedBtnFunction={() => setToggleDialog(false)}
            filledBtnText={"Yes"}
            filledBtnFunction={handleSubmit(handleEditModal)}
            toggleDialog={toggleDialog}
          />
          <DateTimeModal
            openModal={openDateModal}
            onClose={handleCloseDateModal}
            updateSelect={updateSelect}
          />
        </section>
      </div>
    </>
  );
}

export default CreatePaymentLinks;
